import { t } from '@lingui/core/macro';

import { useRegions } from '@/api/settings';
import {
  CategoryFilter,
  ComboboxPickerFilter,
  encodeFilterFieldName,
  FilterField,
  useFilterForm,
} from '@/components/filters';
import type { FilterOperatorMulti } from '@/components/InstantSearch';
import type { FilterComponentProps } from '@/providers/TableState';

type Props = FilterComponentProps & {
  mode?: 'multiple';
};

const RegionFilter = ({ name, label, infoPopover, compact, mode = 'multiple' }: Props) => {
  const form = useFilterForm();
  const { regions, isLoading, error } = useRegions({ includeBlanks: true });

  return (
    <form.AppField name={encodeFilterFieldName(name)}>
      {(field) => (
        <FilterField
          data-testid="region-filter"
          label={label}
          infoPopover={infoPopover}
          hideLabel={!compact}
        >
          {compact ? (
            <ComboboxPickerFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              mode={mode}
              singlePlaceholder={t`Select Region...`}
              multiplePlaceholder={t`Select Regions...`}
              multipleLoadingPlaceholder={t`Loading Regions...`}
              items={regions}
              isLoading={isLoading}
              error={error}
              notFoundContent={t`No regions were found...`}
            />
          ) : (
            <CategoryFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              selectionMode={mode}
              isLoading={isLoading}
              error={error}
              options={regions}
            />
          )}
        </FilterField>
      )}
    </form.AppField>
  );
};

export default RegionFilter;
